export default {"src":"/_next/static/media/spinner.3693c331.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};